import type { UseQueryOptions } from "@tanstack/react-query";

const queryOptionsDefaults = {
    throwOnError: true
} satisfies Partial<UseQueryOptions>;

type QueryOptionsDefaults = typeof queryOptionsDefaults;
type QueryOptionsOverrides = Partial<UseQueryOptions>;

export function createQueryOptions<TClientOptions extends object>(clientOptions: TClientOptions, overrides?: QueryOptionsOverrides): TClientOptions & QueryOptionsDefaults {
    return {
        ...queryOptionsDefaults,
        ...clientOptions,
        ...overrides
    };
}
